/* ADD Knowledge categories */
export const ADD_SKILL = "ADD_SKILL"
export const ADD_SKILL_SUCCESS = "ADD_SKILL_SUCCESS"
export const ADD_SKILL_CLEAN = "ADD_SKILL_CLEAN"
export const ADD_SKILL_ERROR = "ADD_SKILL_ERROR"
